<mj-record-form-container [Record]="record" [FormComponent]="this"
    (Navigate)="OnFormNavigate($event)"
    (DeleteRequested)="OnDeleteRequested()"
    (FavoriteToggled)="OnFavoriteToggled()"
    (HistoryRequested)="OnHistoryRequested()"
    (ListManagementRequested)="OnListManagementRequested()">

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="before-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         FIELD PANELS
         ======================================== -->
    <!-- Contact Information Section -->
    <mj-collapsible-panel
        SectionKey="contactInformation"
        SectionName="Contact Information"
        Icon="fa fa-address-card"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Email"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Email"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Phone"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Mobile"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <!-- Personal Information Section -->
    <mj-collapsible-panel
        SectionKey="personalInformation"
        SectionName="Personal Information"
        Icon="fa fa-user"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="FirstName"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="LastName"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Bio"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ProfilePhotoURL"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="URL"
        ></mj-form-field>

    </mj-collapsible-panel>

    <!-- Professional Profile Section -->
    <mj-collapsible-panel
        SectionKey="professionalProfile"
        SectionName="Professional Profile"
        Icon="fa fa-briefcase"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Title"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="OrganizationID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Industry"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="JobFunction"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="YearsInProfession"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="LinkedInURL"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="URL"
        ></mj-form-field>

    </mj-collapsible-panel>

    <!-- Engagement and Membership Section -->
    <mj-collapsible-panel
        SectionKey="engagementAndMembership"
        SectionName="Engagement and Membership"
        Icon="fa fa-chart-line"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="JoinDate"
            Type="datepicker"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="PreferredLanguage"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Timezone"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="EngagementScore"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="LastActivityDate"
            Type="datepicker"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <!-- Location Details Section -->
    <mj-collapsible-panel
        SectionKey="locationDetails"
        SectionName="Location Details"
        Icon="fa fa-map-marker-alt"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="City"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="State"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Country"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="PostalCode"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <!-- System Metadata Section -->
    <mj-collapsible-panel
        SectionKey="systemMetadata"
        SectionName="System Metadata"
        Icon="fa fa-cog"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_CreatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_UpdatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_Latitude"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_Longitude"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         RELATED ENTITY PANELS
         ======================================== -->

    <!-- Board Members Section -->
    <mj-collapsible-panel
        SectionKey="boardMembers"
        SectionName="Board Members"
        Icon="fa fa-users"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('boardMembers')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Board Members','MemberID')"
                [NewRecordValues]="NewRecordValues('Board Members','MemberID')"
                [AllowLoad]="IsSectionExpanded('boardMembers')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('boardMembers', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Certifications Section -->
    <mj-collapsible-panel
        SectionKey="certifications"
        SectionName="Certifications"
        Icon="fa fa-certificate"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('certifications')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Certifications','MemberID')"
                [NewRecordValues]="NewRecordValues('Certifications','MemberID')"
                [AllowLoad]="IsSectionExpanded('certifications')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('certifications', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Committees Section -->
    <mj-collapsible-panel
        SectionKey="committees"
        SectionName="Committees"
        Icon="fa fa-users"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('committees')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Committees','ChairMemberID')"
                [NewRecordValues]="NewRecordValues('Committees','ChairMemberID')"
                [AllowLoad]="IsSectionExpanded('committees')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('committees', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Continuing Educations Section -->
    <mj-collapsible-panel
        SectionKey="continuingEducations"
        SectionName="Continuing Educations"
        Icon="fa fa-graduation-cap"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('continuingEducations')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Continuing Educations','MemberID')"
                [NewRecordValues]="NewRecordValues('Continuing Educations','MemberID')"
                [AllowLoad]="IsSectionExpanded('continuingEducations')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('continuingEducations', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Event Registrations Section -->
    <mj-collapsible-panel
        SectionKey="eventRegistrations"
        SectionName="Event Registrations"
        Icon="fa fa-calendar-check"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('eventRegistrations')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Event Registrations','MemberID')"
                [NewRecordValues]="NewRecordValues('Event Registrations','MemberID')"
                [AllowLoad]="IsSectionExpanded('eventRegistrations')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('eventRegistrations', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Forum Categories Section -->
    <mj-collapsible-panel
        SectionKey="forumCategories"
        SectionName="Forum Categories"
        Icon="fa fa-comments"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('forumCategories')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Forum Categories','LastPostAuthorID')"
                [NewRecordValues]="NewRecordValues('Forum Categories','LastPostAuthorID')"
                [AllowLoad]="IsSectionExpanded('forumCategories')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('forumCategories', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Forum Moderations Section -->
    <mj-collapsible-panel
        SectionKey="forumModerationsModeratedByID"
        SectionName="Forum Moderations"
        Icon="fa fa-shield-alt"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('forumModerationsModeratedByID')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Forum Moderations','ModeratedByID')"
                [NewRecordValues]="NewRecordValues('Forum Moderations','ModeratedByID')"
                [AllowLoad]="IsSectionExpanded('forumModerationsModeratedByID')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('forumModerationsModeratedByID', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Forum Posts Section -->
    <mj-collapsible-panel
        SectionKey="forumPostsEditedByID"
        SectionName="Forum Posts"
        Icon="fa fa-comments"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('forumPostsEditedByID')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Forum Posts','EditedByID')"
                [NewRecordValues]="NewRecordValues('Forum Posts','EditedByID')"
                [AllowLoad]="IsSectionExpanded('forumPostsEditedByID')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('forumPostsEditedByID', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Forum Threads Section -->
    <mj-collapsible-panel
        SectionKey="forumThreadsLastReplyAuthorID"
        SectionName="Forum Threads"
        Icon="fa fa-comments"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('forumThreadsLastReplyAuthorID')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Forum Threads','LastReplyAuthorID')"
                [NewRecordValues]="NewRecordValues('Forum Threads','LastReplyAuthorID')"
                [AllowLoad]="IsSectionExpanded('forumThreadsLastReplyAuthorID')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('forumThreadsLastReplyAuthorID', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Invoices Section -->
    <mj-collapsible-panel
        SectionKey="invoices"
        SectionName="Invoices"
        Icon="fa fa-file-invoice"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('invoices')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Invoices','MemberID')"
                [NewRecordValues]="NewRecordValues('Invoices','MemberID')"
                [AllowLoad]="IsSectionExpanded('invoices')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('invoices', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Member Follows Section -->
    <mj-collapsible-panel
        SectionKey="memberFollows"
        SectionName="Member Follows"
        Icon="fa fa-rss"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('memberFollows')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Member Follows','FollowerID')"
                [NewRecordValues]="NewRecordValues('Member Follows','FollowerID')"
                [AllowLoad]="IsSectionExpanded('memberFollows')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('memberFollows', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Memberships Section -->
    <mj-collapsible-panel
        SectionKey="memberships"
        SectionName="Memberships"
        Icon="fa fa-id-card"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('memberships')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Memberships','MemberID')"
                [NewRecordValues]="NewRecordValues('Memberships','MemberID')"
                [AllowLoad]="IsSectionExpanded('memberships')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('memberships', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Post Attachments Section -->
    <mj-collapsible-panel
        SectionKey="postAttachments"
        SectionName="Post Attachments"
        Icon="fa fa-paperclip"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('postAttachments')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Post Attachments','UploadedByID')"
                [NewRecordValues]="NewRecordValues('Post Attachments','UploadedByID')"
                [AllowLoad]="IsSectionExpanded('postAttachments')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('postAttachments', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Post Reactions Section -->
    <mj-collapsible-panel
        SectionKey="postReactions"
        SectionName="Post Reactions"
        Icon="fa fa-thumbs-up"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('postReactions')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Post Reactions','MemberID')"
                [NewRecordValues]="NewRecordValues('Post Reactions','MemberID')"
                [AllowLoad]="IsSectionExpanded('postReactions')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('postReactions', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Products Section -->
    <mj-collapsible-panel
        SectionKey="products"
        SectionName="Products"
        Icon="fa fa-cheese"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('products')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Products','MemberID')"
                [NewRecordValues]="NewRecordValues('Products','MemberID')"
                [AllowLoad]="IsSectionExpanded('products')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('products', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Resource Downloads Section -->
    <mj-collapsible-panel
        SectionKey="resourceDownloads"
        SectionName="Resource Downloads"
        Icon="fa fa-download"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('resourceDownloads')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Resource Downloads','MemberID')"
                [NewRecordValues]="NewRecordValues('Resource Downloads','MemberID')"
                [AllowLoad]="IsSectionExpanded('resourceDownloads')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('resourceDownloads', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Resource Ratings Section -->
    <mj-collapsible-panel
        SectionKey="resourceRatings"
        SectionName="Resource Ratings"
        Icon="fa fa-star"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('resourceRatings')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Resource Ratings','MemberID')"
                [NewRecordValues]="NewRecordValues('Resource Ratings','MemberID')"
                [AllowLoad]="IsSectionExpanded('resourceRatings')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('resourceRatings', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Resource Versions Section -->
    <mj-collapsible-panel
        SectionKey="resourceVersions"
        SectionName="Resource Versions"
        Icon="fa fa-file-archive"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('resourceVersions')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Resource Versions','CreatedByID')"
                [NewRecordValues]="NewRecordValues('Resource Versions','CreatedByID')"
                [AllowLoad]="IsSectionExpanded('resourceVersions')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('resourceVersions', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Resources Section -->
    <mj-collapsible-panel
        SectionKey="resources"
        SectionName="Resources"
        Icon="fa fa-file-alt"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('resources')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Resources','AuthorID')"
                [NewRecordValues]="NewRecordValues('Resources','AuthorID')"
                [AllowLoad]="IsSectionExpanded('resources')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('resources', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Campaign Members Section -->
    <mj-collapsible-panel
        SectionKey="campaignMembers"
        SectionName="Campaign Members"
        Icon="fa fa-user-tag"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('campaignMembers')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Campaign Members','MemberID')"
                [NewRecordValues]="NewRecordValues('Campaign Members','MemberID')"
                [AllowLoad]="IsSectionExpanded('campaignMembers')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('campaignMembers', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Chapter Memberships Section -->
    <mj-collapsible-panel
        SectionKey="chapterMemberships"
        SectionName="Chapter Memberships"
        Icon="fa fa-users"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('chapterMemberships')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Chapter Memberships','MemberID')"
                [NewRecordValues]="NewRecordValues('Chapter Memberships','MemberID')"
                [AllowLoad]="IsSectionExpanded('chapterMemberships')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('chapterMemberships', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Chapter Officers Section -->
    <mj-collapsible-panel
        SectionKey="chapterOfficers"
        SectionName="Chapter Officers"
        Icon="fa fa-users"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('chapterOfficers')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Chapter Officers','MemberID')"
                [NewRecordValues]="NewRecordValues('Chapter Officers','MemberID')"
                [AllowLoad]="IsSectionExpanded('chapterOfficers')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('chapterOfficers', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Committee Memberships Section -->
    <mj-collapsible-panel
        SectionKey="committeeMemberships"
        SectionName="Committee Memberships"
        Icon="fa fa-users"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('committeeMemberships')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Committee Memberships','MemberID')"
                [NewRecordValues]="NewRecordValues('Committee Memberships','MemberID')"
                [AllowLoad]="IsSectionExpanded('committeeMemberships')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('committeeMemberships', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Competition Judges Section -->
    <mj-collapsible-panel
        SectionKey="competitionJudges"
        SectionName="Competition Judges"
        Icon="fa fa-gavel"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('competitionJudges')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Competition Judges','MemberID')"
                [NewRecordValues]="NewRecordValues('Competition Judges','MemberID')"
                [AllowLoad]="IsSectionExpanded('competitionJudges')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('competitionJudges', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Enrollments Section -->
    <mj-collapsible-panel
        SectionKey="enrollments"
        SectionName="Enrollments"
        Icon="fa fa-graduation-cap"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('enrollments')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Enrollments','MemberID')"
                [NewRecordValues]="NewRecordValues('Enrollments','MemberID')"
                [AllowLoad]="IsSectionExpanded('enrollments')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('enrollments', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Forum Moderations Section -->
    <mj-collapsible-panel
        SectionKey="forumModerationsReportedByID"
        SectionName="Forum Moderations"
        Icon="fa fa-shield-alt"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('forumModerationsReportedByID')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Forum Moderations','ReportedByID')"
                [NewRecordValues]="NewRecordValues('Forum Moderations','ReportedByID')"
                [AllowLoad]="IsSectionExpanded('forumModerationsReportedByID')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('forumModerationsReportedByID', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Forum Posts Section -->
    <mj-collapsible-panel
        SectionKey="forumPostsAuthorID"
        SectionName="Forum Posts"
        Icon="fa fa-comments"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('forumPostsAuthorID')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Forum Posts','AuthorID')"
                [NewRecordValues]="NewRecordValues('Forum Posts','AuthorID')"
                [AllowLoad]="IsSectionExpanded('forumPostsAuthorID')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('forumPostsAuthorID', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Forum Threads Section -->
    <mj-collapsible-panel
        SectionKey="forumThreadsAuthorID"
        SectionName="Forum Threads"
        Icon="fa fa-comments"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('forumThreadsAuthorID')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Forum Threads','AuthorID')"
                [NewRecordValues]="NewRecordValues('Forum Threads','AuthorID')"
                [AllowLoad]="IsSectionExpanded('forumThreadsAuthorID')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('forumThreadsAuthorID', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Advocacy Actions Section -->
    <mj-collapsible-panel
        SectionKey="advocacyActions"
        SectionName="Advocacy Actions"
        Icon="fa fa-bullhorn"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('advocacyActions')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Advocacy Actions','MemberID')"
                [NewRecordValues]="NewRecordValues('Advocacy Actions','MemberID')"
                [AllowLoad]="IsSectionExpanded('advocacyActions')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('advocacyActions', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Email Sends Section -->
    <mj-collapsible-panel
        SectionKey="emailSends"
        SectionName="Email Sends"
        Icon="fa fa-envelope-open-text"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('emailSends')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Email Sends','MemberID')"
                [NewRecordValues]="NewRecordValues('Email Sends','MemberID')"
                [AllowLoad]="IsSectionExpanded('emailSends')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('emailSends', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-related" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>
</mj-record-form-container>
        